module.exports = __webpack_public_path__ + "img/560.a8150e1a.jpg";